import { render, staticRenderFns } from "./AdvanceItem.vue?vue&type=template&id=86146fbe&scoped=true"
import script from "./AdvanceItem.vue?vue&type=script&lang=js"
export * from "./AdvanceItem.vue?vue&type=script&lang=js"
import style0 from "@styles/other/home/homeHotwords.css?vue&type=style&index=0&id=86146fbe&prod&scoped=true&lang=css&external"
import style1 from "./AdvanceItem.vue?vue&type=style&index=1&id=86146fbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86146fbe",
  null
  
)

export default component.exports